<template>
    <div class="date-container / flex" :class="{isDesktopScreen, isTabletScreen}">
        <div>
            <div class="date-container__weekday" :class="{'bold-font': workAmount > 0}">{{ weekday }}</div>
            <div class="date-container__date">{{ date }}</div>
        </div>
    </div>
    <div class="date-container__workAmount" :class="{'bold-font': workAmount > 0}">{{ workAmount }}</div>
</template>
<script setup lang="ts">
    import {useScreenSizeStore} from '@common/stores';
    import {storeToRefs} from 'pinia';

    defineProps<{
        weekday: string;
        date: string;
        workAmount: number;
    }>();

    const screenSizeStore = useScreenSizeStore();
    const {isTabletScreen, isDesktopScreen} = storeToRefs(screenSizeStore);
</script>
<style lang="scss" scoped>
    .date-container {
        align-items: center;

        &__weekday {
            font-size: var(--joy-font-size-primary-300);
            width: 75px;
            margin-right: 8px;
        }

        &__date {
            font-weight: var(--joy-font-weight-normal);
            font-size: var(--joy-core-spacing-3);
            color: var(--joy-color-neutral-40);
            min-width: 70px;
        }

        &__workAmount {
            font-size: var(--joy-font-size-primary-300);
        }

        .tooltip {
            overflow: hidden;

            & > span > p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .isDesktopScreen {
        .tooltip {
            max-width: 500px;

            & > span > p {
                max-width: 500px;
            }
        }
    }

    .isTabletScreen {
        .tooltip {
            max-width: 40vw;

            & > span > p {
                max-width: 40vw;
            }
        }
    }

    .bold-font {
        font-weight: var(--joy-font-weight-bold);
    }
</style>
